import React from 'react'

import './styles.scss'

const Main = () => {
	return (
		<div className="discount-main">
			<h2 className="discount-main__title">What our clients say</h2>
			<h3 className="discount-main__subtitle">
				<span>92%</span> of our customers claim to have made 100% amazing pics
				with Refine App
			</h3>
			<img
				className="discount-main__comment"
				src="images/discount/comment1.png"
				alt="comment1"
			/>
			<img
				className="discount-main__comment"
				src="images/discount/comment2.png"
				alt="comment2"
			/>
		</div>
	)
}

export { Main }
